// UI strings as a message catalogue (English only for now; SPEC §6 asks for a structure that
// translations can be added to). Use `t("key", { vars })`.

const en = {
  "app.name": "The Infinite",
  "app.subtitle": "an endless beat",
  "app.tagline": "One endless song at 125 BPM, written 30 seconds at a time by people everywhere.",
  "nav.river": "Listen",
  "nav.create": "Create",
  "nav.fame": "Hall of Fame",
  "nav.mixtapes": "Top100 Mixtapes",
  "nav.tapes": "My Tapes",
  "nav.join": "Create account",
  "nav.account": "Account",
  "nav.signin": "Sign in",
  "skin.label": "Skin",
  "skin.studio": "Studio Feel",
  "skin.hifi": "Hifi Feel",
  "skin.eigenbloom": "Eigenbloom",
  "skin.zoo": "Zoo",
  "river.join": "Join Stream",
  "river.joining": "Tuning in…",
  "river.leave": "Leave Stream",
  "river.today": "Today",
  "river.listeners": "{n} listening",
  "river.listenersUnknown": "— listening",
  "river.nextDay": "Next day starts in {t}",
  "river.listView": "List view",
  "river.laneView": "River view",
  "river.nowPlaying": "Now playing",
  "river.upNext": "Up next",
  "river.filler": "Wizard filler",
  "river.dawn": "Dawn",
  "river.formerContributor": "former contributor",
  "card.by": "by {author}",
  "card.plays": "Plays {time}",
  "card.played": "Played {time}",
  "card.licence": "Licence: CC BY 4.0 — credit: {credit}",
  "card.wizardShare": "Wizard share",
  "card.preview": "Preview this song",
  "card.stopPreview": "Back to the song",
  "card.report": "Report",
  "card.close": "Close",
  "card.open": "Open song page",
} as const;

export type MessageKey = keyof typeof en;
const catalogue: Record<MessageKey, string> = en;

export function t(key: MessageKey, vars: Record<string, string | number> = {}): string {
  return catalogue[key].replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? `{${k}}`));
}
